import { useState } from "react";
import { BarChart3 } from "lucide-react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { TipCard } from "../components/TipCard";
import { DemoBadge, SectionHeading } from "../components/ui";
import { matches, tips } from "../data/demo";

export function TipsPage() {
  const [competition, setCompetition] = useState("All");
  const competitions = [
    "All",
    ...new Set(matches.map((match) => match.competition)),
  ];
  const filtered =
    competition === "All"
      ? tips
      : tips.filter(
          (tip) =>
            matches.find((match) => match.id === tip.matchId)?.competition ===
            competition,
        );
  return (
    <div className="page-shell py-10 sm:py-14">
      <SEO
        title="Today's free betting tips"
        description="Browse today's demo football tips with publication odds, confidence and short reasoning."
        path="/tips"
      />
      <div className="flex flex-wrap items-start justify-between gap-5">
        <SectionHeading
          headingLevel={1}
          eyebrow="Today’s card"
          title="Free betting tips"
          description="Every selection shows the odds recorded at publication. Demo picks are not live recommendations."
        />
        <Link
          to="/tips/performance"
          className="flex items-center gap-2 rounded-xl border border-soft px-4 py-3 text-sm font-bold"
        >
          <BarChart3 size={17} className="text-lime" />
          Performance
        </Link>
      </div>
      <div className="mb-6 flex gap-2 overflow-x-auto pb-2 hide-scrollbar">
        {competitions.map((item) => (
          <button
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-bold ${competition === item ? "bg-lime" : "border border-soft bg-white/[.03] text-muted"}`}
            onClick={() => setCompetition(item)}
            key={item}
          >
            {item}
          </button>
        ))}
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {filtered.map((tip) => (
          <TipCard key={tip.id} tip={tip} />
        ))}
      </div>
      <div className="mt-5">
        <DemoBadge />
      </div>
    </div>
  );
}
